export var StreetSearchEnum;
(function (StreetSearchEnum) {
    StreetSearchEnum["Name"] = "Street name";
    StreetSearchEnum["AlternativeName"] = "Alternative name";
    StreetSearchEnum["Type"] = "Type";
    StreetSearchEnum["Place"] = "Place";
    StreetSearchEnum["Ward"] = "Ward";
})(StreetSearchEnum || (StreetSearchEnum = {}));
export var StreetSearchOption;
(function (StreetSearchOption) {
    StreetSearchOption["Street"] = "Street";
})(StreetSearchOption || (StreetSearchOption = {}));
